import { render, staticRenderFns } from "./RemoveModal.vue?vue&type=template&id=546199ce&scoped=true&"
import script from "./RemoveModal.vue?vue&type=script&lang=js&"
export * from "./RemoveModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveModal.vue?vue&type=style&index=0&id=546199ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546199ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('546199ce')) {
      api.createRecord('546199ce', component.options)
    } else {
      api.reload('546199ce', component.options)
    }
    module.hot.accept("./RemoveModal.vue?vue&type=template&id=546199ce&scoped=true&", function () {
      api.rerender('546199ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/addresses/components/RemoveModal.vue"
export default component.exports